import PageHero from '../components/PageHero';

const MAP_QUERY = '31217 Pauba Rd Suite 202 Temecula CA 92592';

const faqs = [
  {
    q: 'Do I need an appointment, or can I just walk in?',
    a: "Walk-ins are welcome whenever a stylist has an opening. Because every stylist keeps their own book, we'd suggest booking ahead so you get the chair, the stylist, and the time you want. We're open Monday through Saturday, 10am to 5pm, and closed Sundays.",
  },
  {
    q: "I'm a new client. Who should I book with?",
    a: "Reach out and we'll point you to the stylist whose work fits what you're after. Each of our stylists keeps a portfolio on the Team page, so find the one whose color or cuts look like what you want, then message them directly.",
  },
  {
    q: 'How does booking work here?',
    a: 'The Loft is a salon of independent stylists, so each one schedules their own appointments, usually through Instagram or a quick text. New clients can contact the salon for a referral. Existing clients, just reach out to your stylist directly for a new appointment or a change.',
  },
  {
    q: 'Can you fix color from another salon or a box dye?',
    a: "Yes. Color correction is one of the things our stylists do most. Bring a photo of where your hair is now and where you'd like it to go, and we'll talk through a realistic plan. Sometimes it's one session, sometimes a few.",
  },
  {
    q: 'Do you work with every hair type and texture?',
    a: 'We do. Women, men, and kids, straight through curly and coily, and everything from a quick trim to balayage, vivids, extensions, keratin smoothing, and bridal styling.',
  },
  {
    q: 'How much will my service cost?',
    a: "Every head of hair, and every stylist, is a little different, so pricing is set per stylist and confirmed at your consultation. Message the stylist you have in mind for a quote, or contact the salon and we'll help you figure it out.",
  },
  {
    q: 'Where are you, and where do I park?',
    a: "We're on the second floor at 31217 Pauba Rd, Suite 202 in Temecula, facing Pauba Road. Parking is around the back of the building. Once you have parked, take the stairs or the elevator up to the second floor, then follow the walkway around toward the front and you'll find us.",
  },
  {
    q: 'Do you do wedding or special-occasion hair?',
    a: 'Up-dos, bridal hair, and makeup, yes. For weddings, we recommend booking a trial ahead of the day so everything is dialed in before you walk down the aisle.',
  },
];

const faqSchema = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
});

const Contact = () => (
  <div className="page">
    <PageHero kicker="Contact" title="Come say hello.">
      Appointments are encouraged, and walk-ins are always welcome. Here is
      everything you need to reach us or find your way in.
    </PageHero>

    <section className="section">
      <div className="container">
        <div className="contact__details">
          <div className="contact__block reveal">
            <h3>Call</h3>
            <p><a className="link" href="tel:9516946016">(951) 694-6016</a></p>
          </div>
          <div className="contact__block reveal" data-reveal="60">
            <h3>Email</h3>
            <p><a className="link" href="mailto:theloftsalon@tlst.us">theloftsalon@tlst.us</a></p>
          </div>
          <div className="contact__block reveal" data-reveal="120">
            <h3>Visit</h3>
            <address>
              31217 Pauba Rd, Suite 202<br />
              Temecula, CA 92592<br />
              <span className="contact__muted">Vineyard Commons, 2nd floor, streetside</span>
            </address>
          </div>
          <div className="contact__block reveal" data-reveal="180">
            <h3>Hours</h3>
            <p>
              Monday – Saturday, 10:00am – 5:00pm<br />
              <span className="contact__muted">Closed Sundays</span>
            </p>
          </div>
        </div>
      </div>
    </section>

    <section className="section--tight section--warm">
      <div className="container">
        <div className="section-head section-head--center reveal">
          <span className="kicker">Good to know</span>
          <h2>Before your first visit</h2>
          <p className="lede">
            A few things new clients ask us most. Anything we did not cover here,
            just call the salon or message your stylist.
          </p>
        </div>
        <div className="faq reveal">
          {faqs.map((f, i) => (
            <details className="faq__item" key={f.q} open={i === 0}>
              <summary>{f.q}</summary>
              <p className="faq__answer">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>

    <section className="section--tight">
      <div className="container">
        <div className="contact__map frame reveal">
          <iframe
            title="The Loft Salon Temecula location"
            src={`https://www.google.com/maps?q=${encodeURIComponent(MAP_QUERY)}&output=embed`}
            width="100%"
            height="460"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>

    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: faqSchema }} />
  </div>
);

export default Contact;
